import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  del,
  formDataPatch,
  formDataPost,
  get,
  patch,
  post,
} from "helpers/api_helper";
import {
  ADD_AMENITY,
  DELETE_AMENITY,
  GET_ALL_AMENITY,
  GET_AMENITY_DETAILS,
  GET_AMENITY_LIST,
  UPDATE_AMENITY,
  UPDATE_AMENITY_STATUS,
} from "helpers/url_helper";

export const getAllAmenities = createAsyncThunk(
  GET_ALL_AMENITY,
  async (payload) => {
    const response = await post(GET_ALL_AMENITY, payload);
    return response;
  }
);

export const getAmenityList = createAsyncThunk(GET_AMENITY_LIST, async () => {
  const response = await get(GET_AMENITY_LIST);
  return response;
});

export const addAmenity = createAsyncThunk(ADD_AMENITY, async (payload) => {
  const response = await formDataPost(ADD_AMENITY, payload);
  return response;
});

export const updateAmenity = createAsyncThunk(
  UPDATE_AMENITY,
  async (payload) => {
    const response = await formDataPatch(UPDATE_AMENITY, payload);
    return response;
  }
);

export const deleteAmenity = createAsyncThunk(
  DELETE_AMENITY,
  async (payload) => {
    const response = await del(DELETE_AMENITY, payload);
    return response;
  }
);

export const updateAmenityStatus = createAsyncThunk(
  UPDATE_AMENITY_STATUS,
  async (payload) => {
    const response = await patch(UPDATE_AMENITY_STATUS, payload);
    return response;
  }
);

export const getAmenityDetails = createAsyncThunk(
  GET_AMENITY_DETAILS,
  async (payload) => {
    const response = await post(GET_AMENITY_DETAILS, payload);
    return response;
  }
);
